export const APP_PLATFORM = {
  ANDROID: 1,
  IOS: 2,
};

export const APP_PLATFORM_OPTIONS = [
  { value: APP_PLATFORM.ANDROID, label: "Android" },
  { value: APP_PLATFORM.IOS, label: "iOS" },
];

export const getPlatformLabel = (platform) =>
  APP_PLATFORM_OPTIONS.find((option) => option.value === Number(platform))?.label ||
  "Unknown";
